import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { TextField } from "react-admin";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { "sensor-type": highlightedSensorTypelIds = [] } =
    useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedSensorTypelIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      split
      type="table"
      {...props}
      perPage={10}
      key={highlightedSensorTypelIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="sm"
        cardContent={<Card />}
        target="sensor-types"
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="code" variant="body2" />
        <TextField source="name" />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
